import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { AttendanceClosingLedgerSearchSchema } from './-ledger/-zod-schema';
export const Route = createFileRoute('/_staff/attendances/_layout/records/')({
  validateSearch: zodValidator(AttendanceClosingLedgerSearchSchema)
});